var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBitcoinActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bitcoin-5",
    "data-name": "Bitcoin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47 32v14h-2v3h-2v4h-22v-4h-2v-3h-2v-14h2v-3h1v-4h24v4h1v3z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 29v-4h-12v4h1 10z",
    fill: "#9bc9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 32v-3h-10v3h2 6z",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 49h-2-10-2v4h14z",
    fill: "#9bc9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 46h-2-6-2v3h10z",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 32h6v14h-6z",
    fill: "#c2dff6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 53h-2-14-22-14-2v4h54z",
    fill: "#57a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 57h-2v4h58v-4h-2z",
    fill: "#2488ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 29h10 1v-4h-12v4z",
    fill: "#9bc9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 32h2 6 2v-3h-10z",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 49v4h14v-4h-2-10z",
    fill: "#9bc9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 46v3h10v-3h-2-6z",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 32h6v14h-6z",
    fill: "#c2dff6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 39,
    fill: "#fbb040",
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 28c-.338 0-.67.021-1 .05a11 11 0 0 1 0 21.9c.33.029.662.05 1 .05a11 11 0 0 0 0-22z",
    fill: "#f7941d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 20h52v5h-52z",
    fill: "#57a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 32h3v14h-3z",
    fill: "#96c8ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 32h3v14h-3z",
    fill: "#96c8ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 20h52v2h-52z",
    fill: "#4e94e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58 20h-52l26-14z",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 14,
    fill: "#f1f2f2",
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.1 18.5-28.1-15.5-28.095 15.5a1.751 1.751 0 0 0 -.905 1.533 1.75 1.75 0 0 0 2.6 1.532l26.4-14.565 26.405 14.568a1.75 1.75 0 0 0 2.595-1.532 1.751 1.751 0 0 0 -.9-1.536z",
    fill: "#57a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 25h12v2h-12z",
    fill: "#8cb5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 25h12v2h-12z",
    fill: "#8cb5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 53h54v2h-54z",
    fill: "#4e94e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 57h58v2h-58z",
    fill: "#207ae5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 34a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-8a1 1 0 0 0 -1-1z",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 34a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-8a1 1 0 0 0 -1-1z",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.618 39a3.983 3.983 0 0 0 -2.618-7v-1a1 1 0 0 0 -2 0v1h-1.017c0-.31.009-.657.017-.977a1 1 0 0 0 -.977-1.023.975.975 0 0 0 -1.023.977c-.01.417-.016.739-.02 1.023h-1.98a1 1 0 0 0 0 2h1v10h-1a1 1 0 0 0 0 2h2v1a1 1 0 0 0 2 0v-1h1v1a1 1 0 0 0 2 0v-1a3.983 3.983 0 0 0 2.618-7zm-.618-3a2 2 0 0 1 -2 2h-4v-4h4a2 2 0 0 1 2 2zm-2 8h-4v-4h4a2 2 0 0 1 0 4z",
    fill: "#ef4136"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinActive);
export default __webpack_public_path__ + "static/media/bitcoinActive.705ebfbc96fb8d257a22b6e672dacdda.svg";
export { ForwardRef as ReactComponent };